import EmployeeEvaluation from "features/evoluate";

// The list and the details share one two-pane page; the :employeeId route preselects an employee.
const EmployeeEvaluationDetailsPage = () => {
  return <EmployeeEvaluation />;
};

export default EmployeeEvaluationDetailsPage;
